import React from "react";

// Decorative double line above each month heading.
export default function DoubleLine() {
    return (
        <div className="w-[86px]">
            <div className="border-t-[3px] border-[#1c2938] rounded-full" />
            <div className="border-t-[3px] border-[#1c2938] rounded-full mt-[8px]" />
        </div>
    );
}
